/**
 * Sprache der Oberfläche: wie im Portal (cloud-v2 `lib/oberflaeche.ts`) die
 * erste bevorzugte Sprache des Geräts, für die es eine Übersetzung gibt,
 * sonst Englisch; meldet das Gerät nichts, Deutsch. Eine gespeicherte Wahl
 * unter `ui.language` (gemeinsamer Name mit Portal und Apple-Apps, #5418)
 * geht vor. Übersetzt ist bisher der Anmeldeschirm; was fehlt, bleibt deutsch.
 */
import { de, type TextSchluessel, type Texte } from '../i18n/de'
import { en } from '../i18n/en'

export const OBERFLAECHE_KEY = 'ui.language'
export type OberflaechenSprache = 'de' | 'en'
const TEXTE: Record<OberflaechenSprache, Texte> = { de, en }
const SPRACHEN: readonly OberflaechenSprache[] = ['de', 'en']

function kuerzelAus(angabe: string): string {
  return angabe.trim().toLowerCase().split(/[-_]/)[0] || ''
}

export function oberflaecheAusGeraet(liste: readonly string[] = typeof navigator === 'undefined' ? [] : navigator.languages?.length ? navigator.languages : [navigator.language]): OberflaechenSprache {
  const kuerzel = liste.map(kuerzelAus).filter(Boolean)
  if (!kuerzel.length) return 'de'
  return (kuerzel.find((k) => (SPRACHEN as readonly string[]).includes(k)) as OberflaechenSprache | undefined) ?? 'en'
}

export function aktiveSprache(): OberflaechenSprache {
  try {
    const v = localStorage.getItem(OBERFLAECHE_KEY)
    if (v === 'de' || v === 'en') return v
  } catch { /* ohne Speicher gilt das Gerät */ }
  return oberflaecheAusGeraet()
}

/** Beim Start: `<html lang>` nachziehen. */
export function oberflaecheAnwenden(): void {
  try { document.documentElement.lang = aktiveSprache() } catch { /* ohne Dokument */ }
}

/** Text in einer Sprache. Fehlt er dort, gilt der deutsche. Platzhalter `{name}` werden ersetzt. */
export function text(sprache: OberflaechenSprache, schluessel: TextSchluessel, werte?: Record<string, string | number>): string {
  const roh = TEXTE[sprache][schluessel] || de[schluessel]
  return werte ? roh.replace(/\{(\w+)\}/g, (ganz, name: string) => (name in werte ? String(werte[name]) : ganz)) : roh
}
